export const getStorageItem = key => localStorage.getItem(`sportsscale_${key}`);

export const setStorageItem = (key, val) => localStorage.setItem(`sportsscale_${key}`, val);

export const removeStorageItem = key => localStorage.removeItem(`sportsscale_${key}`);
